import "./ViewedExecuteSopsTable.css";


export const ViewedExecuteSopsConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "incident_type_id",
        label: "executesopsformlabels.incident",
        type: "select",
        options: [],
        
      },

      {
        name: "task_name",
        label: "executesopsformlabels.sop",
        type: "select",
      },
      {
        name: "assign_to_id",
        label: "executesopsformlabels.name",
        type: "input-ds",
        readOnly: true, // Add readonly property
        disabled: true, // Add disabled property
      },
      {
        name: "description",
        label: "executesopsformlabels.description",
        type: "text_area",
      },
    ],
  },
];



export const viewtaskcolumnsForExportView = [
  { label: "SOP Name", key: "task_name" },
  { label: "Incident Type", key: "incident_type" },
  {label:"Assigned To",key: "role_name"},
  {label: "Created On", key: "created_on"},
  {label: "Updated By", key: "updated_by"},
  { label: "Task Type", key: "task_type" },
];

export const SoPFormConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "name",
        label: "sopformlabels.name",
        type: "input",
      },
      {
        name: "sop_task",
        label: "sopformlabels.task",
        type: "multi_select",
        mandatory: "true",
        options: [],
      },
      {
        name: "sop_resource",
        label: "sopformlabels.resource",
        type: "multi_select",
        options: [],
      },
      {
        name: "description",
        label: "sopformlabels.description",
        type: "text_area",
      },
    ],
  },
];
